if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.productSection = document.querySelector('[data-mvp-product-section]');
        this._wasSubmitButtonDisabledOnLoad = false;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.SubmitButtonComponent = this.closest('add-to-cart-button');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('.shared-button__leading-label');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.bindEvents();
      }

      bindEvents() {
        // Prevent duplicating events since that element replaceable in variant-swatches.js
        if (window.Shopify[this.id]) {
          return;
        }

        window.Shopify[this.id] = true;

        // No need to run custom validation for products without size
        if (!document.getElementById('product-form-size-option')) return;

        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
          if (event.data?.target instanceof HTMLElement) {
            const sizeOption = event.data?.target?.closest('#product-form-size-option');

            if (sizeOption) {
              this.cleanSizeValidation();
            }
          }
        });

        // Make default selection visible
        subscribe(PUB_SUB_EVENTS.sizeSelectedOptionClick, () => {
          this.SubmitButtonComponent.restoreLastSavedState();
          this.cleanSizeValidation();
        });
      }

      isFormValid() {
        // No need to run custom validation for products without size
        const productVariants = document.getElementById('data-replaceable-variants');
        if (!productVariants || !productVariants?.querySelector('#product-form-size-option')) {
          return true;
        }

        // If a particular size wasn't chosen, validation failed (default preselection doesn't count)
        if (this.productSection && this.productSection.getAttribute('data-size-selected') === 'false') {
          return false;
        }

        return true;
      }

      cleanSizeValidation() {
        if (this._hasCleanedSizeValidation) return;
        this._hasCleanedSizeValidation = true;
        window.sizeSelected = true;
        this.SubmitButtonComponent.unfreeze();

        // wait for the handleUpdateProductInfo() processing
        setTimeout(() => {
          this.productSection?.setAttribute('data-size-selected', 'true');
          this.productSection?.classList.remove('is-error');
        }, 700);
      }

      showValidationError() {
        this.productSection?.classList.add('is-error');
        publish(PUB_SUB_EVENTS.submitButtonChange, { text: window.variantStrings.select_size, froze: true });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.isFormValid()) {
          this.showValidationError();
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.dataset.addedToCart === 'true') return this.cart.open();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('is-loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const formData = new FormData(this.form);

        const data = {
          items: [{}],
        };

        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          const sectionsUrl = window.location.pathname;

          data.sections = sections;
          data.sections_url = sectionsUrl;

          this.cart.setActiveElement(document.activeElement);
        }

        for (const [key, value] of formData.entries()) {
          data.items[0][key] = value;
        }

        const completeWithProductInput = document.getElementById('complete-with-product-id');

        if (completeWithProductInput?.checked && completeWithProductInput?.value) {
          data.items.push({
            id: completeWithProductInput.value,
            quantity: 1,
          });
        }

        config.body = JSON.stringify(data);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);

              const addToCartSuccessEvent = new CustomEvent('add-to-cart-success', {
                bubbles: true,
                detail: { response },
              });

              this.dispatchEvent(addToCartSuccessEvent);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('is-loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
